export type SupportCenterFormKind =
  | 'psicologico'
  | 'nutricional'
  | 'fitness'
  | 'juridico'
  | 'social'

export const SUPPORT_CENTER_FORM_KIND_LABELS: Record<SupportCenterFormKind, string> = {
  psicologico: 'Psicológico',
  nutricional: 'Nutricional',
  fitness: 'Fitness',
  juridico: 'Jurídico',
  social: 'Assistência Social',
}

export function isSupportCenterFormKind(value: unknown): value is SupportCenterFormKind {
  return (
    value === 'psicologico' ||
    value === 'nutricional' ||
    value === 'fitness' ||
    value === 'juridico' ||
    value === 'social'
  )
}

/**
 * Kind operacional da assistência.
 * A key do catálogo prevalece quando é um dos formulários implementados.
 * Key de catálogo fora dessa lista mantém o form_kind já gravado na coluna.
 */
export function resolveAssistanceFormKind(
  specificFormKey: unknown,
  columnFormKind: unknown
): SupportCenterFormKind | null {
  if (isSupportCenterFormKind(specificFormKey)) return specificFormKey
  return isSupportCenterFormKind(columnFormKind) ? columnFormKind : null
}

/** Formulário do agendamento: vem da assistência (specific_form_key / form_kind). */
export function appointmentFormKind(
  appointment: {
    assistance?: {
      form_kind?: unknown
      specific_form_key?: unknown
      specific_form?: { form_key?: unknown } | null
    } | null
  } | null | undefined
): SupportCenterFormKind | null {
  const assistance = appointment?.assistance
  if (!assistance) return null
  return resolveAssistanceFormKind(
    assistance.specific_form?.form_key ?? assistance.specific_form_key,
    assistance.form_kind
  )
}

export const ASSISTANCE_FORM_KIND_MISSING =
  'A assistência deste agendamento não tem formulário específico. Cadastre em Parâmetros → Formulários e vincule na Assistência.'

export type SupportCenterSpecializationAssistanceRef = {
  id: string
  name: string
  code: string
}

export interface SupportCenterSpecialization {
  id: string
  name: string
  description: string | null
  assistances: SupportCenterSpecializationAssistanceRef[]
  created_at: string
  updated_at: string
  deleted_at: string | null
  deleted_by: string | null
  deleted_reason: string | null
}

export type SupportCenterSpecializationInput = {
  id?: string
  name: string
  description: string
  /** IDs das assistências vinculadas (N:N). */
  assistance_ids: string[]
}

export interface SupportCenterProfileOption {
  id: string
  name: string
  email?: string | null
}

export interface SupportCenterSpecializationAssignment {
  id: string
  user_id: string
  specialization_id: string
  created_at: string
  created_by: string | null
  deleted_at: string | null
  deleted_by: string | null
  deleted_reason: string | null
  profile?: { id: string; name: string } | null
  specialization?: { id: string; name: string } | null
}

export interface SupportCenterUserAvailability {
  id: string
  user_id: string
  weekdays: number[]
  hours: number[]
  created_at: string
  updated_at: string
  created_by: string | null
  updated_by: string | null
  deleted_at: string | null
  deleted_by: string | null
  deleted_reason: string | null
}

export type SupportCenterUserAvailabilityInput = {
  user_id: string
  weekdays: number[]
  hours: number[]
  actor_id: string
}

export interface SupportCenterUserUnavailability {
  id: string
  user_id: string
  starts_on: string
  ends_on: string
  all_day: boolean
  hours: number[]
  reason: string | null
  created_at: string
  updated_at: string
  created_by: string | null
  deleted_at: string | null
  deleted_by: string | null
  deleted_reason: string | null
  profile?: { id: string; name: string } | null
}

export type SupportCenterUserUnavailabilityInput = {
  id?: string
  user_id: string
  starts_on: string
  ends_on: string
  all_day: boolean
  hours: number[]
  reason: string
  actor_id: string
}
